export default __webpack_public_path__ + "static/media/taxi.febf5ac0.svg";